.active {
    filter: drop-shadow(0 0 10px #000000);
}
